//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleInput from '../shared/simpleInput';

export default {
  name: 'DpTextarea',
  extends: SimpleInput,
  props: {
    monospace: { type: Boolean, default: false },
    resize: { type: String, default: 'both' },
    spellcheck: { type: Boolean, default: true },
    disableTab: { type: Boolean, default: false },
  },
  methods: {
    keyEvent(event) {
      if (this.disableTab && event.key === 'Tab') {
        event.preventDefault();
      }
    },
    handleDrop(event) {
      if (event === null) { return; }
      event.preventDefault();

      const reader = new FileReader();
      reader.onload = (loadedFile) => {
        const value = loadedFile.target.result;
        if (value === null || typeof value !== 'string') {
          return;
        }
        const inputEvent = { target: { value } };
        this.handleInput(inputEvent);
      };

      const file = (event.dataTransfer || event.originalEvent.dataTransfer).files[0];
      reader.readAsText(file);
    },
    handleScroll(e) {
      this.$emit('scroll', e);
    },
  },
};
